import { createEpicMiddleware } from "redux-observable";
import { configureStore } from "@reduxjs/toolkit";

import modalReducer from "@/store/slices/modalSlice";
import authReducer from "@/features/auth/duck/auth";
import propertyReducer from "@/features/property/duck/property";
import userReducer from "@/features/user/duck/user";
import inboxReducer from "@/features/user/duck/inbox";
import dashboardReducer from "@/features/dashboard/duck/dashboard";
import subscriptionReducer from "@/features/property/duck/subscription";
import marketInsightsReducer from "@/features/marketInsights/duck/marketInsights";
import userSubscriptionReducer from "@/features/user/duck/userSubscription";
import aiChatBotReducer from "@/features/aiAgentChatBot/duck/aiChatBot";

import rootEpic from "@/store/epic/index";
const epicMiddleware = createEpicMiddleware();

export const store = configureStore({
  reducer: {
    modal: modalReducer,
    auth: authReducer,
    property: propertyReducer,
    user: userReducer,
    chat: inboxReducer,
    subscription: subscriptionReducer,
    dashboard: dashboardReducer,
    marketInsight: marketInsightsReducer,
    userSubscription: userSubscriptionReducer,
    aiChatBot: aiChatBotReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["modal/showModal", "auth.error"],
        ignoredActionPaths: ["payload"],
        ignoredPaths: ["modal.modalContent", "auth.error"]
      }
    }).concat(epicMiddleware)
});

epicMiddleware.run(rootEpic);

export default store;
